import React from 'react';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import ConfirmOrDenyBooking from './atom/ConfirmOrDenyBooking';

const ConfirmOrDenyBookingPage = ({ pageType }) => {
    const { id, hash } = useParams();
    return (
        <Grid container spacing={4} className="page" justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={6} lg={4} container spacing={2}>
                <ConfirmOrDenyBooking id={id} hash={hash} pageType={pageType} />
            </Grid>
        </Grid>
    );
};
export default ConfirmOrDenyBookingPage;
